
import { RefreshCw, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface RegenerateButtonProps {
  onClick: () => void;
  isRegenerating: boolean;
  isInitialMessage?: boolean;
}

const RegenerateButton = ({ 
  onClick, 
  isRegenerating, 
  isInitialMessage = false
}: RegenerateButtonProps) => {
  const getButtonText = () => {
    if (isRegenerating) {
      return isInitialMessage ? "Changing tone..." : "Regenerating...";
    }
    return isInitialMessage ? "Change Tone" : "Regenerate";
  };
  
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onClick}
      disabled={isRegenerating}
      className="h-9"
    >
      {isRegenerating ? (
        <>
          <Loader2 className="h-4 w-4 mr-1.5 animate-spin" />
          {getButtonText()}
        </>
      ) : (
        <>
          <RefreshCw className="h-4 w-4 mr-1.5" />
          {getButtonText()}
        </>
      )}
    </Button>
  );
};

export default RegenerateButton;
